<div class="flex-container">
  <div class="container">
    <form
      class="f-col blank-form"
      [formGroup]="generateTokenForm"
      (ngSubmit)="onGenerateToken()"
    >
      <div class="section-heading mt-3">
        <h2 class="h2-heading">Generate Token</h2>
      </div>

      <div class="section-content">
        <div class="inner-contentsection">
          <div class="f-row">
            <div class="f-col">
              <mat-form-field appearance="fill">
                <mat-label>{{ content?.['b2b.book.passenger.emailaddress'] }}</mat-label>
                <input
                  matInput
                  formControlName="emailAddress"
                  placeholder="Enter your email address"
                  (keypress)="_CommonService.blockInvalidCharacters($event)"
                  (paste)="_CommonService.onPasteBlocked($event)"
                  (contextmenu)="_CommonService.disableRightClick($event)"
                  autocomplete="off"
                />
                <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
                <mat-error
                  *ngIf="
                    generateTokenForm.get('emailAddress')?.hasError('required') &&
                    generateTokenForm.get('emailAddress')?.touched
                  "
                >
                  Email is required.
                </mat-error>
                <mat-error
                  *ngIf="
                    generateTokenForm.get('emailAddress')?.hasError('email') &&
                    generateTokenForm.get('emailAddress')?.touched
                  "
                >
                  {{ content?.['phrases.b2b.managetraveler.entervalidemail'] }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="inner-action">
          <button
            mat-button
            type="submit"
            class="button--primary-large"
            [disabled]="generateTokenForm.invalid || isSubmitting"
            [class.disabled]="generateTokenForm.invalid || isSubmitting"
          >
            <mat-spinner
              class="button"
              *ngIf="isSubmitting"
              [diameter]="20"
            ></mat-spinner>
            <span *ngIf="!isSubmitting">Generate Token</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

